import { CompanyDepartments } from 'services/api';
import * as yup from 'yup';

import { budgetTypeButtons } from './components/buttons';

export const allowanceSchema = yup.object({
  name: yup.string().required('Name is required.'),
  editable: yup.boolean(),
  budget_type: yup.mixed().oneOf(budgetTypeButtons.map((b) => b.id)),
  input_budget: yup.string().when('editable', {
    is: true,
    then: yup.string().required('Budget is required.').min(1)
  }),
  budget: yup.number().required().min(0),
  allowance_date_from: yup.string().when('budget_type', {
    is: 'custom',
    then: yup.string().required().length(10)
  }),
  applicable_time_from: yup.string().required().length(5),
  applicable_time_to: yup.string().required().length(5),
  allow_flexible_locations: yup.boolean(),
  applicable_company_locations: yup
    .array()
    .nullable()
    .when('allow_flexible_locations', {
      is: false,
      then: yup.array().required().min(1, 'At least 1 address is required.')
    }),
  applicable_type: yup.string(),
  ordering_rule_company_department: yup
    .array()
    .nullable()
    .when('applicable_type', {
      is: 'group',
      then: yup.array().min(1, 'At least 1 deparment is required.')
    }),
  applicable_users: yup
    .array()
    .nullable()
    .when('applicable_type', {
      is: 'user',
      then: yup.array().min(1, 'At least 1 user is required.')
    })
});
